<div class="container" [class.mobile]="isMobile">
    <div class="header">
        <span></span>
        <span>
            <h3>help</h3>
        </span>
        <button mat-icon-button aria-label="Close" (click)="close()">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <mat-divider></mat-divider>

    <ng-container *ngIf="articlesList$ | async as articlesList">
        <div *ngIf="articlesList.isLoading; else articlesTemplate" class="loading-container">
            <ngx-skeleton-loader [count]="5" appearance="line"></ngx-skeleton-loader>
        </div>

        <div *ngIf="articlesList.showError">
            <p class="error-message">There was an error when getting articles.</p>
        </div>

        <ng-template #articlesTemplate>
            <div class="articles-section" *ngIf="articlesList.list">
                <div *ngIf="articlesList.list.length">
                    <p>
                        <strong>Need help?</strong> Here are some articles to get you started. You
                        must have an Agilent Community account and sign in to the Agilent Community
                        to view the articles. To create a community account, visit
                        <a (click)="onOpenExternalLink(links.gettingStarted)">
                            Agilent Community Getting Started
                        </a>.
                    </p>
                    <ul>
                        <li *ngFor="let article of articlesList.list">
                            <a (click)="onOpenExternalLink(article.link)">{{ article.title }}</a>: {{
                            article.description }}
                        </li>
                    </ul>
                    <mat-divider></mat-divider>
                </div>
                <div class="notes-section">
                    <p>
                        <strong>The Agilent Community</strong>
                    </p>
                    <p>Get answers. Share insights. Build connections.</p>
                    <p>
                        Join the
                        <a (click)="onOpenExternalLink(links.powerMonitoring)"
                            >Agilent Community - CrossLab Connect Power Monitoring Private Group</a
                        >
                        to access technical support articles and connect with other users in the
                        forum.
                    </p>
                    <p>
                        If you need assistance accessing the Agilent Community please email us at
                        <a [href]="'mailto:' + links.mailto">{{ links.mailto }}</a>
                    </p>
                </div>
            </div>
        </ng-template>
    </ng-container>
</div>
